// Check if we're on a page that needs the gallery
function shouldInitializeGallery() {
  // Check if we're on a product page with a gallery
  const hasProductGallery = document.querySelector(".product-glide") !== null;
  const hasProductForm =
    document.querySelector('form[action*="/cart/add"]') !== null;
  const hasProductTitle =
    document.querySelector('h1[class*="product"]') !== null;

  // Only initialize if we have a product gallery
  return hasProductGallery;
}

// Wait for both DOM and Glide.js to be available
function waitForGlideAndInitialize(attempts = 0) {
  // First check if we should even initialize
  if (!shouldInitializeGallery()) {
    console.log(
      "No product gallery found on this page - gallery initialization skipped"
    );
    return;
  }

  if (typeof window.Glide !== "undefined") {
    // Initialize global variables
    window.variantImageMap = {}; // Maps variant IDs to image IDs
    window.imageSlideMap = {}; // Maps image IDs to slide indexes
    window.productGlide = null;
    window.initialLoadComplete = false;

    // Setup everything
    initializeGallery();
  } else if (attempts < 50) {
    // Wait up to 5 seconds
    // Wait a bit and try again
    setTimeout(() => waitForGlideAndInitialize(attempts + 1), 100);
  } else {
    console.log(
      "Glide.js not available after 5 seconds - gallery initialization skipped"
    );
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Start waiting for Glide.js
  waitForGlideAndInitialize();
});

// Function to update arrow visibility based on current slide
function updateArrowVisibility() {
  if (!window.productGlide) {
    console.log('No productGlide instance found');
    return;
  }
  
  const prevArrow = document.querySelector('.slider-nav-arrow.prev');
  const nextArrow = document.querySelector('.slider-nav-arrow.next');
  
  if (!prevArrow || !nextArrow) {
    console.log('Arrow elements not found');
    return;
  }
  
  const currentIndex = window.productGlide.index;
  
  // Get total slides from the actual slides in the DOM
  const slides = document.querySelectorAll('.product-glide .glide__slide');
  const totalSlides = slides.length;
  
  console.log(`🔍 Arrow visibility check: Slide ${currentIndex + 1} of ${totalSlides}`);
  console.log('Previous arrow classes before:', prevArrow.className);
  console.log('Next arrow classes before:', nextArrow.className);
  
  // Hide previous arrow on first slide
  if (currentIndex === 0) {
    prevArrow.classList.add('hidden');
    console.log('✅ Hiding previous arrow (first slide)');
  } else {
    prevArrow.classList.remove('hidden');
    console.log('✅ Showing previous arrow');
  }
  
  // Hide next arrow on last slide
  if (currentIndex === totalSlides - 1) {
    nextArrow.classList.add('hidden');
    console.log('✅ Hiding next arrow (last slide)');
  } else {
    nextArrow.classList.remove('hidden');
    console.log('✅ Showing next arrow');
  }
  
  console.log('Previous arrow classes after:', prevArrow.className);
  console.log('Next arrow classes after:', nextArrow.className);
}

// Main initialization function
function initializeGallery() {
  console.log("Initializing product media gallery");

  if (typeof window.Glide === "undefined") {
    console.log("Glide.js library not found - gallery initialization skipped");
    return;
  }

  // Find the gallery element
  const galleryElement = document.querySelector(".product-glide");
  if (!galleryElement) {
    console.log("No gallery element found");
    return;
  }

  // Clear any existing Glide instance
  if (window.productGlide) {
    try {
      window.productGlide.destroy();
    } catch (e) {
      console.log("Error destroying existing Glide instance");
    }
  }

  // First build the variant-image mapping
  buildVariantImageMapping();

  // Get info about the slides
  const originalSlides = document.querySelectorAll(
    ".glide__slide:not(.glide__slide--clone)"
  );
  const allSlides = document.querySelectorAll(".glide__slide");
  const cloneSlides = document.querySelectorAll(".glide__slide--clone");

  console.log(
    `Total slides: ${allSlides.length} (${originalSlides.length} original, ${cloneSlides.length} clones)`
  );

  // Determine clone pattern
  let leadingClones = 0;
  for (let i = 0; i < allSlides.length; i++) {
    if (allSlides[i].classList.contains("glide__slide--clone")) {
      leadingClones++;
    } else {
      break;
    }
  }

  const trailingClones = cloneSlides.length - leadingClones;
  console.log(
    `Clone pattern: ${leadingClones} leading, ${trailingClones} trailing`
  );

  // Save clone pattern globally
  window.galleryClonePattern = {
    leadingClones,
    trailingClones,
    totalClones: cloneSlides.length,
  };

  // Map each slide to its image ID
  mapSlidesToImages(originalSlides);

  // CRITICAL UPDATE: Check if the first slide is already a clone
  // If so, we need to skip past the clones to the first original slide
  let firstOriginalIndex = 0;
  let firstOriginalDomIndex = -1;

  if (originalSlides.length > 0) {
    // Get the first original slide
    const firstOriginalSlide = originalSlides[0];

    // Find its actual position in the DOM (accounting for clones)
    firstOriginalDomIndex = Array.from(allSlides).indexOf(firstOriginalSlide);

    if (firstOriginalDomIndex === -1) {
      console.error("CRITICAL: Could not find first original slide in DOM!");
      firstOriginalDomIndex = leadingClones; // Fallback to calculated position
    }

    console.log(
      `First original slide found at DOM position ${firstOriginalDomIndex}`
    );
  }

  // IMPROVED: Store positions globally for reference
  window.firstOriginalSlideIndex = 0; // Logical index (among original slides)
  window.firstOriginalDomIndex = firstOriginalDomIndex; // DOM position

  console.log(`Setting Glide to start at DOM index ${firstOriginalDomIndex}`);

  // Check if mobile device
  const isMobile = window.innerWidth <= 768;
  
  // Initialize the Glide instance with the correct DOM position
  window.productGlide = new Glide(galleryElement, {
    type: "carousel",
    startAt: firstOriginalDomIndex, // Use actual DOM position!
    perView: 1,
    gap: 0,
    rewind: isMobile ? true : false, // Enable infinite loop on mobile
    // DISABLE dragging completely
    dragThreshold: false,
    // Ensure animations are enabled
    animationDuration: 400,
    // Add more configuration options to make navigation smoother
    animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    // Disable dragging completely
    draggable: false,
    // Prevent auto-binding of controls so we can handle them manually
    bindArrows: false,
    // Disable swipe completely
    swipeThreshold: false,
    // Disable touch events
    touchRatio: 0,
  });

  // CRITICAL: We need to capture the original slide positions before mounting
  window.originalSlidePositions = [];
  originalSlides.forEach((slide, index) => {
    window.originalSlidePositions.push({
      index,
      slide,
      image: slide.querySelector("img")?.src || "No image",
    });
  });

  // CRITICAL CHANGE: Add event listeners to the Glide instance to prevent blocking navigation
  window.productGlide.on("run.before", function (move) {
    // We need to preserve this event but avoid interference with navigation
    console.log("Glide run.before event", move);

    // Don't block navigation events!
    return true;
  });

  // Mount Glide immediately
  window.productGlide.mount();
  console.log("Glide instance mounted");

  // CRITICAL: Add more Glide events to ensure proper functionality
  window.productGlide.on("mount.after", function () {
    console.log("Glide mounted successfully, ensuring navigation works");

    // Reset any pointer-events or touch handling issues
    const track = document.querySelector(".product-glide .glide__track");
    if (track) {
      track.style.pointerEvents = "auto";
      track.style.touchAction = "pan-y";
    }
    
    // Initialize arrow visibility
    updateArrowVisibility();
  });

  window.productGlide.on("run", function (move) {
    console.log(`Glide running to ${move.direction}`);
    // Update arrow visibility after slide change
    setTimeout(updateArrowVisibility, 100);
  });

  window.productGlide.on("swipe.move", function () {
    console.log("Swipe detected");
  });

  // IMPORTANT: After mounting, Glide may have rearranged slides and added clones
  // So we need to re-examine the DOM to understand the new structure
  setTimeout(() => {
    const postMountSlides = document.querySelectorAll(".glide__slide");
    const postMountOriginals = document.querySelectorAll(
      ".glide__slide:not(.glide__slide--clone)"
    );
    const postMountClones = document.querySelectorAll(".glide__slide--clone");

    console.log(
      `Post-mount: ${postMountSlides.length} total slides, ${postMountOriginals.length} original, ${postMountClones.length} clones`
    );

    // Check if the first original slide is still at the expected position
    if (postMountOriginals.length > 0) {
      const firstSlide = postMountOriginals[0];
      const newPosition = Array.from(postMountSlides).indexOf(firstSlide);
      console.log(
        `First original slide is now at DOM position ${newPosition} (was ${firstOriginalDomIndex})`
      );

      // Update our global reference if it changed
      if (newPosition !== -1 && newPosition !== firstOriginalDomIndex) {
        window.firstOriginalDomIndex = newPosition;
      }
    }

    // Analyze the current active slide
    const activeSlide = document.querySelector(".glide__slide--active");
    if (activeSlide) {
      const isClone = activeSlide.classList.contains("glide__slide--clone");
      const activeIndex = Array.from(postMountSlides).indexOf(activeSlide);
      const img = activeSlide.querySelector("img");

      console.log(
        `Active slide: ${activeIndex} (${isClone ? "CLONE" : "ORIGINAL"})`
      );
      console.log(
        `Active image: ${
          img ? img.alt || img.src.split("/").pop() : "No image"
        }`
      );

      // Force navigation to the first original slide if we're currently on a clone
      if (isClone && window.firstOriginalDomIndex !== -1) {
        console.log(
          `Currently on a clone, forcing navigation to first original slide at ${window.firstOriginalDomIndex}`
        );
        window.productGlide.go(`=${window.firstOriginalDomIndex}`);
      }
    }
  }, 50);

  // Set up navigation (after mounting)
  setupArrowNavigation();
  setupKeyboardNavigation();
  // CRITICAL ADD: Add explicit touch setup
  setupTouchNavigation();

  // After slider is ready, show the first/default variant image
  setTimeout(() => {
    // Ensure we're showing correct variant
    const initialVariantId = getSelectedVariantId();

    // CRITICAL: Before trying to display variants, make sure navigation is working
    // Test navigation to ensure it's functional
    const navTest = function () {
      console.log("Testing navigation functionality before variant display");

      // Save current index
      let currentIndex = window.productGlide.index;

      // Try to move forward and then back
      let slideWorking = true;
      try {
        window.productGlide.go(">");
        // Check if we actually moved
        slideWorking = window.productGlide.index !== currentIndex;

        // Go back to original position
        setTimeout(() => {
          window.productGlide.go("=" + currentIndex);
          console.log(`Navigation test ${slideWorking ? "PASSED" : "FAILED"}`);

          // Now show the variant
          if (initialVariantId) {
            console.log(
              `Showing image for initial variant: ${initialVariantId}`
            );
            showVariantImage(initialVariantId);
          } else {
            // If no variant found, make sure we're at the first original slide
            forceCorrectFirstSlide();
          }

          // Then set up variant change listeners
          setupVariantChangeListeners();
        }, 50);
      } catch (e) {
        console.error("Error testing navigation:", e);
        // Still try to display variant despite navigation issues
        if (initialVariantId) {
          showVariantImage(initialVariantId);
        }
        setupVariantChangeListeners();
      }
    };

    // Run the navigation test after a short delay
    setTimeout(navTest, 50);
  }, 150);

  // NEW FUNCTION: Force correct first slide display
  function forceCorrectFirstSlide() {
    // Find the currently active slide
    const activeSlide = document.querySelector(".glide__slide--active");
    if (!activeSlide) return;

    // Check if it's a clone
    const isClone = activeSlide.classList.contains("glide__slide--clone");

    // If it's a clone OR not the first original slide, fix it
    if (isClone || window.productGlide.index !== window.firstOriginalDomIndex) {
      console.log(
        `Forcing navigation to first original slide at ${window.firstOriginalDomIndex}`
      );
      window.productGlide.go(`=${window.firstOriginalDomIndex}`);

      // Analyze what we're looking at after the change
      setTimeout(() => {
        const newActiveSlide = document.querySelector(".glide__slide--active");
        if (newActiveSlide) {
          const img = newActiveSlide.querySelector("img");
          console.log(
            `Now showing: ${
              img ? img.alt || img.src.split("/").pop() : "No image"
            }`
          );
        }
      }, 50);
    }
  }

  // Set up touch navigation (ensure swiping works)
  function setupTouchNavigation() {
    // CRITICAL ADD: Explicitly ensure touch/drag functionality works
    console.log("Setting up touch navigation");

    // Find the track element
    const track = document.querySelector(".product-glide .glide__track");
    if (!track) {
      console.log("Could not find glide track element");
      return;
    }

    // Make sure touch events aren't being blocked
    const slides = track.querySelectorAll(".glide__slide");
    slides.forEach((slide) => {
      slide.style.touchAction = "pan-y";
      slide.style.userSelect = "none";

      // Prevent clicks on slide content from stopping propagation
      const clickables = slide.querySelectorAll(
        "a, button, input, select, textarea"
      );
      clickables.forEach((el) => {
        el.addEventListener("mousedown", (e) => e.stopPropagation(), {
          passive: true,
        });
        el.addEventListener("touchstart", (e) => e.stopPropagation(), {
          passive: true,
        });
      });
    });

    console.log("Touch navigation enhancements applied");
  }

  // Show variant image function - completely rewritten to be more direct
  function showVariantImage(variantId) {
    if (!variantId || !window.productGlide) {
      console.log("No variant ID or Glide instance");
      return false;
    }

    console.log(`Showing image for variant: ${variantId}`);

    // Get all slides
    const originalSlides = document.querySelectorAll(
      ".glide__slide:not(.glide__slide--clone)"
    );
    const allSlides = document.querySelectorAll(".glide__slide");

    if (originalSlides.length === 0) {
      console.log("No slides found");
      return false;
    }

    // Clone pattern analysis
    const totalSlides = allSlides.length;
    const originalCount = originalSlides.length;
    const cloneCount = totalSlides - originalCount;
    const clonesPerEnd = Math.floor(cloneCount / 2);

    console.log(
      `Slide structure: ${totalSlides} total (${originalCount} original, ${cloneCount} clones, ~${clonesPerEnd} per end)`
    );

    // IMPROVED: Attempt all the different ways to find the right slide
    let foundSlideIndex = -1;

    // Method 1: Direct variant->slide mapping (most reliable)
    if (
      window.variantSlideMap &&
      window.variantSlideMap[variantId] !== undefined
    ) {
      foundSlideIndex = window.variantSlideMap[variantId];
      console.log(
        `✓ Found slide directly in variantSlideMap: ${foundSlideIndex}`
      );
    }

    // Method 2: Image ID mapping through variantImageMap
    if (
      foundSlideIndex === -1 &&
      window.variantImageMap &&
      window.variantImageMap[variantId]
    ) {
      const imageId = window.variantImageMap[variantId];
      if (window.imageSlideMap && window.imageSlideMap[imageId] !== undefined) {
        foundSlideIndex = window.imageSlideMap[imageId];
        console.log(`✓ Found slide through image mapping: ${foundSlideIndex}`);
      }
    }

    // Method 3: Media position mapping
    if (
      foundSlideIndex === -1 &&
      window.variantToMediaPosition &&
      window.variantToMediaPosition[variantId] !== undefined
    ) {
      const position = window.variantToMediaPosition[variantId];
      if (
        window.mediaPositionToSlide &&
        window.mediaPositionToSlide[position] !== undefined
      ) {
        foundSlideIndex = window.mediaPositionToSlide[position];
        console.log(`✓ Found slide through media position: ${foundSlideIndex}`);
      }
    }

    // Method 4: Shopify variant API
    if (foundSlideIndex === -1) {
      try {
        if (window.ShopifyAnalytics?.meta?.product) {
          const product = window.ShopifyAnalytics.meta.product;
          const variant = product.variants.find(
            (v) => v.id.toString() === variantId
          );

          if (variant) {
            // Try featured_media first
            if (variant.featured_media?.id) {
              const mediaId = variant.featured_media.id.toString();

              // Look for data-media-id on slides
              for (let i = 0; i < originalSlides.length; i++) {
                const slide = originalSlides[i];
                const slideMediaId = slide.getAttribute("data-media-id");

                if (slideMediaId === mediaId) {
                  foundSlideIndex = i;
                  console.log(
                    `✓ Found slide with exact media ID match: ${foundSlideIndex}`
                  );
                  break;
                }
              }
            }

            // If not found, try position
            if (
              foundSlideIndex === -1 &&
              variant.featured_position !== undefined
            ) {
              // In Shopify, positions are 1-indexed but arrays are 0-indexed
              const adjustedPosition = variant.featured_position - 1;
              if (
                adjustedPosition >= 0 &&
                adjustedPosition < originalSlides.length
              ) {
                foundSlideIndex = adjustedPosition;
                console.log(
                  `✓ Found slide using variant's featured position: ${foundSlideIndex}`
                );
              }
            }
          }
        }
      } catch (e) {
        console.log("Error in Shopify variant API lookup", e);
      }
    }

    // Method 5: Text-based matching with variant options
    if (foundSlideIndex === -1) {
      try {
        const variantOptions = getVariantOptions(variantId);
        if (variantOptions && variantOptions.length > 0) {
          console.log(
            `Looking for text match with options: ${variantOptions.join(", ")}`
          );

          // Try each slide for matching text
          slideSearch: for (let i = 0; i < originalSlides.length; i++) {
            const slide = originalSlides[i];
            const slideImg = slide.querySelector("img");

            if (!slideImg) continue;

            const imgAlt = (slideImg.alt || "").toLowerCase();
            const imgSrc = (slideImg.src || "").toLowerCase();

            for (const option of variantOptions) {
              if (!option) continue;
              const optionText = option.toLowerCase();

              if (
                imgAlt.includes(optionText) ||
                imgSrc.includes(optionText.replace(/ /g, "-"))
              ) {
                foundSlideIndex = i;
                console.log(
                  `✓ Found slide through text matching: ${foundSlideIndex}`
                );

                // Save this for future lookups
                window.variantSlideMap[variantId] = i;

                break slideSearch;
              }
            }
          }
        }
      } catch (e) {
        console.log("Error in text-based variant matching", e);
      }
    }

    // Method 6: Last resort - try all data attributes on slides
    if (foundSlideIndex === -1) {
      console.log("Trying advanced data attribute search on slides...");

      for (let i = 0; i < originalSlides.length; i++) {
        const slide = originalSlides[i];

        // Get all data attributes
        const allAttributes = Array.from(slide.attributes).filter(
          (attr) => attr.name.startsWith("data-") && attr.value
        );

        for (const attr of allAttributes) {
          if (attr.value.includes(variantId)) {
            foundSlideIndex = i;
            console.log(
              `✓ Found variant ID in slide data attribute: ${attr.name}`
            );
            break;
          }
        }

        if (foundSlideIndex !== -1) break;

        // Also check image for data attributes
        const img = slide.querySelector("img");
        if (img) {
          const imgAttributes = Array.from(img.attributes).filter(
            (attr) => attr.name.startsWith("data-") && attr.value
          );

          for (const attr of imgAttributes) {
            if (attr.value.includes(variantId)) {
              foundSlideIndex = i;
              console.log(
                `✓ Found variant ID in image data attribute: ${attr.name}`
              );
              break;
            }
          }
        }

        if (foundSlideIndex !== -1) break;
      }
    }

    // If we found a slide, navigate to it
    if (foundSlideIndex >= 0 && foundSlideIndex < originalSlides.length) {
      // Store for future use
      window.variantSlideMap[variantId] = foundSlideIndex;

      // Get actual DOM position with clone-aware calculation
      const actualIndex = getCloneAwareDomIndex(
        foundSlideIndex,
        originalSlides,
        allSlides
      );

      if (actualIndex !== -1) {
        console.log(
          `✓ Navigate to DOM position ${actualIndex} (slide ${foundSlideIndex})`
        );
        window.productGlide.go(`=${actualIndex}`);

        // Log image info for verification
        setTimeout(() => {
          const activeSlide = document.querySelector(".glide__slide--active");
          if (activeSlide) {
            const img = activeSlide.querySelector("img");
            if (img) {
              console.log(
                `Now showing: ${img.alt || img.src.split("/").pop()}`
              );
            }
          }
        }, 50);

        return true;
      }
    }

    console.log(`⚠️ Could not find slide for variant ${variantId}`);
    return false;
  }

  // NEW FUNCTION: Get the actual DOM index considering clones
  function getCloneAwareDomIndex(originalIndex, originalSlides, allSlides) {
    // First check if we can find the slide directly (most reliable)
    if (originalIndex >= 0 && originalIndex < originalSlides.length) {
      const targetOriginalSlide = originalSlides[originalIndex];
      const directDomIndex = Array.from(allSlides).indexOf(targetOriginalSlide);

      if (directDomIndex !== -1) {
        console.log(
          `Direct DOM lookup: slide ${originalIndex} is at position ${directDomIndex}`
        );
        return directDomIndex;
      }
    }

    // If direct lookup fails, try to calculate it
    // This is a FALLBACK method
    try {
      // Count clones
      const totalSlides = allSlides.length;
      const originalCount = originalSlides.length;
      const cloneCount = totalSlides - originalCount;

      // Most sliders put half the clones at the beginning
      // and half at the end for infinite looping
      const clonesAtStart = Math.floor(cloneCount / 2);

      // Calculate position with clones
      const calculatedPosition = clonesAtStart + originalIndex;
      console.log(
        `Calculated DOM position: ${calculatedPosition} (${clonesAtStart} clones + index ${originalIndex})`
      );

      // Verify the calculated position is within bounds
      if (calculatedPosition >= 0 && calculatedPosition < totalSlides) {
        return calculatedPosition;
      }
    } catch (e) {
      console.error("Error calculating clone-aware index:", e);
    }

    // Last resort - return the original index as fallback
    console.log(
      `Warning: Could not find DOM position for slide ${originalIndex}, returning original index`
    );
    return originalIndex;
  }

  // Get variant options for matching
  function getVariantOptions(variantId) {
    // Try Shopify analytics
    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product
    ) {
      const product = window.ShopifyAnalytics.meta.product;
      const variant = product.variants.find(
        (v) => v.id.toString() === variantId
      );

      if (variant) {
        const options = [];

        // Get option values
        for (let i = 1; i <= 3; i++) {
          const optKey = `option${i}`;
          if (variant[optKey]) {
            options.push(variant[optKey]);
          }
        }

        // Also add the title which often contains the option info
        if (variant.title && !options.includes(variant.title)) {
          options.push(variant.title);
        }

        return options.filter((o) => o);
      }
    }

    // Try DOM
    const variantSelect = document.querySelector(
      `select[name="id"] option[value="${variantId}"]`
    );
    if (variantSelect) {
      const text = variantSelect.textContent.trim();
      return text.split(" / ");
    }

    return [];
  }

  // Set up listeners for variant changes
  function setupVariantChangeListeners() {
    console.log("Setting up variant change listeners");

    // Listen for variant selector changes
    document.addEventListener("change", function (e) {
      if (
        e.target.matches(
          'select[name="id"], input[name="id"], [data-option-index]'
        )
      ) {
        console.log("Variant selector changed");

        // Get the new variant ID after a short delay
        setTimeout(() => {
          const variantId = getSelectedVariantId();
          if (variantId) {
            console.log(`Variant changed to: ${variantId}`);

            // CRITICAL FIX: Always go to first slide before showing variant image
            // This ensures variant images display correctly regardless of current slide position
            if (
              window.productGlide &&
              typeof window.productGlide.go === "function"
            ) {
              // Go to the first slide (or the slide we know works for variants)
              window.productGlide.go(`=${window.firstOriginalDomIndex || 0}`);
              console.log("Navigated to first slide for variant change");

              // Short delay to allow slide transition to complete
              setTimeout(() => {
                showVariantImage(variantId);
              }, 100);
            } else {
              // Fallback if Glide is not available
              showVariantImage(variantId);
            }
          }
        }, 100);
      }
    });

    // Listen for variant:change event (used by themes)
    document.addEventListener("variant:change", function (e) {
      console.log("variant:change event detected");
      const variantId = e.detail.variant.id;
      if (variantId) {
        console.log(`Variant changed to: ${variantId} (from event)`);

        // CRITICAL FIX: Always go to first slide before showing variant image
        if (
          window.productGlide &&
          typeof window.productGlide.go === "function"
        ) {
          // Go to the first slide first
          window.productGlide.go(`=${window.firstOriginalDomIndex || 0}`);
          console.log("Navigated to first slide for variant change (event)");

          // Short delay to allow slide transition to complete
          setTimeout(() => {
            showVariantImage(variantId);
          }, 100);
        } else {
          // Fallback if Glide is not available
          showVariantImage(variantId);
        }
      }
    });

    // Also handle options_selection_change event (themes like Debut)
    document.addEventListener("options_selection_change", function (e) {
      console.log("options_selection_change event detected");
      setTimeout(() => {
        const variantId = getSelectedVariantId();
        if (variantId) {
          console.log(`Options changed, new variant: ${variantId}`);

          // CRITICAL FIX: Always go to first slide before showing variant image
          if (
            window.productGlide &&
            typeof window.productGlide.go === "function"
          ) {
            // Go to the first slide first
            window.productGlide.go(`=${window.firstOriginalDomIndex || 0}`);
            console.log("Navigated to first slide for options change");

            // Short delay to allow slide transition to complete
            setTimeout(() => {
              showVariantImage(variantId);
            }, 100);
          } else {
            // Fallback if Glide is not available
            showVariantImage(variantId);
          }
        }
      }, 100);
    });

    // NEW FIX: Handle swatch clicks
    // Many themes use swatches that work through click events rather than change events
    const swatchElements = document.querySelectorAll(
      ".swatch-element, .color-swatch, [data-swatch], [data-value]"
    );
    if (swatchElements.length > 0) {
      console.log(`Found ${swatchElements.length} swatch elements to monitor`);

      swatchElements.forEach((swatch) => {
        // Get all clickable elements within the swatch
        const clickTargets = swatch.querySelectorAll(
          "input, label, a, button, .swatch-image"
        );

        clickTargets.forEach((target) => {
          target.addEventListener("click", function (e) {
            console.log(
              "Swatch clicked:",
              swatch.dataset.value ||
                swatch.getAttribute("data-value") ||
                "unknown"
            );

            // Small delay to allow the variant change to register
            setTimeout(() => {
              // Always go to first slide when a swatch is clicked
              if (
                window.productGlide &&
                typeof window.productGlide.go === "function"
              ) {
                window.productGlide.go(`=${window.firstOriginalDomIndex || 0}`);
                console.log("Navigated to first slide for swatch selection");
              }
            }, 50);
          });
        });
      });
    }
  }

  // Improved arrow navigation
  function setupArrowNavigation() {
    try {
      const galleryElement = document.querySelector(".product-glide");
      if (!galleryElement) return;

      const prevButton = galleryElement.querySelector(".slider-nav-arrow.prev");
      const nextButton = galleryElement.querySelector(".slider-nav-arrow.next");

      if (prevButton && nextButton) {
        // CRITICAL FIX: Make sure arrows are visible and clickable
        prevButton.style.display = "flex";
        nextButton.style.display = "flex";
        prevButton.style.opacity = "1";
        nextButton.style.opacity = "1";
        prevButton.style.pointerEvents = "auto";
        nextButton.style.pointerEvents = "auto";
        prevButton.style.visibility = "visible";
        nextButton.style.visibility = "visible";
        prevButton.style.cursor = "pointer";
        nextButton.style.cursor = "pointer";

        // EXTREME FIX: Make arrows more prominent if they might be hidden
        prevButton.style.zIndex = "999";
        nextButton.style.zIndex = "999";

        // CRITICAL FIX: Remove *ALL* existing handlers to avoid conflicts
        const newPrev = prevButton.cloneNode(true);
        const newNext = nextButton.cloneNode(true);

        // Replace elements with clones to remove all event listeners
        prevButton.parentNode.replaceChild(newPrev, prevButton);
        nextButton.parentNode.replaceChild(newNext, nextButton);

        // Add multiple event types to ensure clicks are captured
        ["click", "mousedown", "touchstart"].forEach((eventType) => {
          newPrev.addEventListener(
            eventType,
            function (e) {
              e.preventDefault();
              e.stopPropagation();
              console.log(`Prev arrow ${eventType}`);
              if (window.productGlide) {
                window.productGlide.go("<");
              }
            },
            { capture: true }
          );

          newNext.addEventListener(
            eventType,
            function (e) {
              e.preventDefault();
              e.stopPropagation();
              console.log(`Next arrow ${eventType}`);
              if (window.productGlide) {
                window.productGlide.go(">");
              }
            },
            { capture: true }
          );
        });

        console.log(
          "Arrow navigation setup complete with fresh event handlers"
        );
      } else {
        console.log("Navigation arrows not found");
      }
    } catch (e) {
      console.error("Error setting up arrow navigation:", e);
    }
  }

  // Navigation functions - simplified to work more reliably
  function navPrev(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (window.productGlide) {
      console.log("Navigate: previous slide");
      window.productGlide.go("<");
    }
  }

  function navNext(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (window.productGlide) {
      console.log("Navigate: next slide");
      window.productGlide.go(">");
    }
  }

  // Setup keyboard navigation
  function setupKeyboardNavigation() {
    // Remove any existing listeners
    document.removeEventListener("keydown", handleKeyNavigation);

    // Add keyboard navigation
    document.addEventListener("keydown", handleKeyNavigation);
    console.log(
      "Keyboard navigation setup complete (use left/right arrow keys)"
    );
  }

  // Navigation handler functions
  function handleKeyNavigation(e) {
    if (!window.productGlide) return;

    switch (e.key) {
      case "ArrowLeft":
        console.log("Keyboard navigation: previous slide");
        window.productGlide.go("<");
        break;
      case "ArrowRight":
        console.log("Keyboard navigation: next slide");
        window.productGlide.go(">");
        break;
    }
  }

  // Extract product JSON from the page
  function extractProductJson() {
    try {
      // Try to find product JSON in script tags
      const scriptTags = document.querySelectorAll(
        'script[type="application/json"]'
      );
      for (const script of scriptTags) {
        const content = script.textContent;
        if (content.includes('"variants":') && content.includes('"product":')) {
          const json = JSON.parse(content);
          if (json.product) {
            return json.product;
          }
        }
      }

      // Try to find in window.ShopifyAnalytics
      if (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product
      ) {
        return window.ShopifyAnalytics.meta.product;
      }

      return null;
    } catch (e) {
      console.log("Error extracting product JSON", e);
      return null;
    }
  }

  // Debug function to check the gallery
  window.checkGalleryStatus = function () {
    console.log("=== GALLERY STATUS ===");

    try {
      // Check if Glide is initialized
      if (!window.productGlide) {
        console.log("❌ Glide is not initialized!");
        return;
      }

      console.log("✅ Glide is initialized");
      console.log(`Current slide index: ${window.productGlide.index}`);

      // Get the active slide
      const activeSlide = document.querySelector(".glide__slide--active");
      if (!activeSlide) {
        console.log("❌ No active slide found");
        return;
      }

      // Get image info
      const activeImg = activeSlide.querySelector("img");
      const imgSrc = activeImg ? activeImg.src : "No image";
      const imgAlt = activeImg ? activeImg.alt : "No alt text";

      console.log("Active slide image:");
      console.log(`- Source: ${imgSrc}`);
      console.log(`- Alt text: ${imgAlt}`);

      // Check current variant
      const currentVariantId = getSelectedVariantId();
      console.log(`Current selected variant ID: ${currentVariantId}`);

      // List available commands
      console.log("\nAvailable commands:");
      console.log("- window.testNavigation() - Test if navigation is working");
      console.log("- window.forceFirstSlide() - Show first slide");
      console.log(
        "- window.forceVariantImage(variantId) - Show specific variant"
      );

      return true;
    } catch (e) {
      console.error("Error checking gallery status:", e);
      return false;
    }
  };

  // Quick test function for navigation
  window.testNavigation = function () {
    console.log("=== TESTING NAVIGATION ===");

    if (!window.productGlide) {
      console.log("❌ No Glide instance available!");
      return false;
    }

    // Store current index
    const startIndex = window.productGlide.index;
    console.log(`Starting at slide ${startIndex}`);

    // Test next slide
    console.log("Going to next slide...");
    window.productGlide.go(">");

    // Check if it moved
    setTimeout(() => {
      const newIndex = window.productGlide.index;
      console.log(`Now at slide ${newIndex}`);

      if (newIndex === startIndex) {
        console.log("❌ Navigation failed - slider did not move!");
      } else {
        console.log("✅ Navigation successful!");

        // Go back to original slide
        console.log("Going back to original slide...");
        window.productGlide.go("<");
      }
    }, 100);

    return true;
  };

  // Update the forceFirstSlide function to use clone-aware logic
  window.forceFirstSlide = function () {
    console.log("=== FORCING FIRST SLIDE ===");

    if (!window.productGlide) {
      console.log("❌ No Glide instance available!");
      return false;
    }

    const originalSlides = document.querySelectorAll(
      ".glide__slide:not(.glide__slide--clone)"
    );

    if (originalSlides.length === 0) {
      console.log("❌ No slides found!");
      return false;
    }

    const allSlides = document.querySelectorAll(".glide__slide");

    // Use our new clone-aware function
    const firstSlideActualIndex = getCloneAwareDomIndex(
      0,
      originalSlides,
      allSlides
    );

    if (firstSlideActualIndex === -1) {
      console.log("❌ Could not find first slide in DOM!");
      return false;
    }

    console.log(
      `Going to first slide at clone-aware index ${firstSlideActualIndex}`
    );
    window.productGlide.go(`=${firstSlideActualIndex}`);

    // Log what we're looking at
    setTimeout(() => {
      const activeSlide = document.querySelector(".glide__slide--active");
      if (activeSlide) {
        const img = activeSlide.querySelector("img");
        console.log(
          `Active slide image: ${img ? img.alt || img.src : "No image"}`
        );
      }
    }, 100);

    return true;
  };

  // Function to force an image for a variant
  window.forceVariantImage = function (variantId) {
    console.log(`=== FORCING VARIANT IMAGE: ${variantId} ===`);

    if (!variantId) {
      console.log("Please provide a variant ID");
      // List available variants
      if (window.ShopifyAnalytics?.meta?.product?.variants) {
        console.log("Available variants:");
        window.ShopifyAnalytics.meta.product.variants.forEach((v) => {
          console.log(`- ${v.id}: ${v.title || "Unknown"}`);
        });
      }
      return false;
    }

    if (!window.productGlide) {
      console.log("Gallery not initialized!");
      return false;
    }

    console.log("Trying all methods to find image for variant...");

    // Try our improved showVariantImage function
    const result = showVariantImage(variantId);

    if (result) {
      console.log("✓ Successfully displayed variant image");

      // Log what we're looking at
      setTimeout(() => {
        const activeSlide = document.querySelector(".glide__slide--active");
        if (activeSlide) {
          const img = activeSlide.querySelector("img");
          console.log(
            `Now showing: ${
              img ? img.alt || img.src.split("/").pop() : "No image"
            }`
          );
        }
      }, 50);

      return true;
    }

    console.log("✗ Failed to find variant image through normal channels");
    console.log(
      "Try running window.analyzeVariantImages() for more diagnostic information"
    );

    return false;
  };

  // Add a new function to examine the clone structure
  window.analyzeGalleryStructure = function () {
    console.log("=== ANALYZING GALLERY STRUCTURE ===");

    const originalSlides = document.querySelectorAll(
      ".glide__slide:not(.glide__slide--clone)"
    );
    const allSlides = document.querySelectorAll(".glide__slide");
    const cloneSlides = document.querySelectorAll(".glide__slide--clone");

    console.log(`Total slides: ${allSlides.length}`);
    console.log(`Original slides: ${originalSlides.length}`);
    console.log(`Clone slides: ${cloneSlides.length}`);

    // Log the order of slides (original vs clone)
    console.log("Slide order in DOM:");
    Array.from(allSlides).forEach((slide, index) => {
      const isClone = slide.classList.contains("glide__slide--clone");
      const img = slide.querySelector("img");
      const imgInfo = img ? img.alt || img.src.split("/").pop() : "No image";
      console.log(`${index}: ${isClone ? "CLONE" : "ORIGINAL"} - ${imgInfo}`);
    });

    // Determine clone pattern
    let leadingClones = 0;
    for (let i = 0; i < allSlides.length; i++) {
      if (allSlides[i].classList.contains("glide__slide--clone")) {
        leadingClones++;
      } else {
        break;
      }
    }

    console.log(`Leading clones: ${leadingClones}`);
    console.log(`Trailing clones: ${cloneSlides.length - leadingClones}`);

    return {
      totalSlides: allSlides.length,
      originalSlides: originalSlides.length,
      cloneSlides: cloneSlides.length,
      leadingClones: leadingClones,
      trailingClones: cloneSlides.length - leadingClones,
    };
  };

  // New diagnostic function to fully analyze variant images
  window.analyzeVariantImages = function () {
    console.log("=== ANALYZING VARIANT IMAGES ===");

    // Get variant data
    let variants = [];
    let variantImages = {};

    // Method 1: ShopifyAnalytics
    if (window.ShopifyAnalytics?.meta?.product?.variants) {
      variants = window.ShopifyAnalytics.meta.product.variants;
      console.log(`Found ${variants.length} variants in ShopifyAnalytics`);
    }
    // Method 2: DOM elements
    else {
      const variantOptions = document.querySelectorAll(
        'select[name="id"] option, input[name="id"]'
      );
      console.log(`Found ${variantOptions.length} variant options in DOM`);

      variantOptions.forEach((option) => {
        const id = option.value;
        if (id) {
          variants.push({
            id,
            title: option.textContent || "Unknown",
          });
        }
      });
    }

    // Analyze each variant
    console.log(`Analyzing ${variants.length} variants for image mappings...`);

    variants.forEach((variant) => {
      const variantId = variant.id.toString();
      console.log(`\nVariant #${variantId}: ${variant.title || "Unknown"}`);

      // Get image ID from multiple sources
      let imageId = null;

      // Method 1: Direct Shopify data
      if (variant.featured_image?.id) {
        imageId = variant.featured_image.id.toString();
        console.log(`✓ Found image ID ${imageId} from variant.featured_image`);
      } else if (variant.featured_media?.id) {
        imageId = variant.featured_media.id.toString();
        console.log(`✓ Found image ID ${imageId} from variant.featured_media`);
      }
      // Method 2: Our mapping
      else if (window.variantImageMap?.[variantId]) {
        imageId = window.variantImageMap[variantId];
        console.log(`✓ Found image ID ${imageId} from variantImageMap`);
      }

      if (imageId) {
        variantImages[variantId] = imageId;

        // Try to find the actual slide
        const slideIndex = window.imageSlideMap?.[imageId];
        if (slideIndex !== undefined) {
          console.log(`✓ Maps to slide index ${slideIndex}`);

          // Try to get the image URL
          const slides = document.querySelectorAll(
            ".glide__slide:not(.glide__slide--clone)"
          );
          if (slides[slideIndex]) {
            const img = slides[slideIndex].querySelector("img");
            if (img) {
              console.log(`✓ Image: ${img.alt || img.src.split("/").pop()}`);
            }
          }
        } else {
          console.log(`✗ No matching slide found for image ID ${imageId}`);
        }
      } else {
        console.log(`✗ No image ID found for variant ${variantId}`);

        // Try text-based matching
        const variantOptions = getVariantOptions(variantId);
        if (variantOptions && variantOptions.length > 0) {
          console.log(
            `Trying text matching with options: ${variantOptions.join(", ")}`
          );

          const slides = document.querySelectorAll(
            ".glide__slide:not(.glide__slide--clone)"
          );
          let foundSlide = false;

          slideSearch: for (let i = 0; i < slides.length; i++) {
            const slide = slides[i];
            const slideImg = slide.querySelector("img");

            if (!slideImg) continue;

            const imgAlt = (slideImg.alt || "").toLowerCase();
            const imgSrc = (slideImg.src || "").toLowerCase();

            // Check if any option matches the image text
            for (const option of variantOptions) {
              if (
                option &&
                (imgAlt.includes(option.toLowerCase()) ||
                  imgSrc.includes(option.toLowerCase().replace(/ /g, "-")))
              ) {
                console.log(
                  `✓ Found possible match at slide ${i}: ${
                    imgAlt || imgSrc.split("/").pop()
                  }`
                );
                foundSlide = true;
                break slideSearch;
              }
            }
          }

          if (!foundSlide) {
            console.log(`✗ No slides match variant options`);
          }
        }
      }
    });

    return {
      variantCount: variants.length,
      imageCount: Object.keys(variantImages).length,
      variantImages,
    };
  };

  // Additional helpful function to find slides by text
  window.findSlideByText = function (searchText) {
    if (!searchText) {
      console.log("Please provide search text");
      return false;
    }

    searchText = searchText.toLowerCase();
    console.log(`Searching for slides containing: "${searchText}"`);

    const slides = document.querySelectorAll(".glide__slide");
    const matches = [];

    slides.forEach((slide, index) => {
      const isClone = slide.classList.contains("glide__slide--clone");
      const img = slide.querySelector("img");
      if (!img) return;

      const imgAlt = (img.alt || "").toLowerCase();
      const imgSrc = (img.src || "").toLowerCase();

      if (imgAlt.includes(searchText) || imgSrc.includes(searchText)) {
        matches.push({
          index,
          isClone,
          text: imgAlt || imgSrc.split("/").pop(),
        });
      }
    });

    if (matches.length === 0) {
      console.log(`No slides found containing "${searchText}"`);
      return false;
    }

    console.log(`Found ${matches.length} matches:`);
    matches.forEach((match) => {
      console.log(
        `- Slide ${match.index} (${match.isClone ? "CLONE" : "ORIGINAL"}): ${
          match.text
        }`
      );
    });

    // Offer to navigate to a match
    console.log('To go to a slide, run: window.productGlide.go("=INDEX")');

    return matches;
  };

  // Comprehensive variant troubleshooting tool
  window.troubleshootVariant = function (variantId) {
    console.log(`=== TROUBLESHOOTING VARIANT ${variantId} ===`);

    if (!variantId) {
      console.log("Please provide a variant ID");
      return false;
    }

    // Step 1: Check if we already have a mapping for this variant
    console.log("Checking existing mappings...");

    if (
      window.variantSlideMap &&
      window.variantSlideMap[variantId] !== undefined
    ) {
      console.log(
        `✓ Found in variantSlideMap: slide index ${window.variantSlideMap[variantId]}`
      );
    } else {
      console.log("✗ Not found in variantSlideMap");
    }

    if (
      window.variantImageMap &&
      window.variantImageMap[variantId] !== undefined
    ) {
      const imageId = window.variantImageMap[variantId];
      console.log(`✓ Found in variantImageMap: image ID ${imageId}`);

      if (window.imageSlideMap && window.imageSlideMap[imageId] !== undefined) {
        console.log(
          `✓ Image maps to slide index ${window.imageSlideMap[imageId]}`
        );
      } else {
        console.log("✗ Image not found in imageSlideMap");
      }
    } else {
      console.log("✗ Not found in variantImageMap");
    }

    // Step 2: Get variant details from all possible sources
    console.log("\nGathering variant details from all sources...");

    // From Shopify Analytics
    let variantDetails = null;
    if (window.ShopifyAnalytics?.meta?.product?.variants) {
      const variant = window.ShopifyAnalytics.meta.product.variants.find(
        (v) => v.id.toString() === variantId
      );
      if (variant) {
        variantDetails = variant;
        console.log("✓ Found variant in ShopifyAnalytics");
        console.log("Title:", variant.title);

        if (variant.featured_media) {
          console.log("Featured media:", variant.featured_media.id);
        }

        if (variant.featured_image) {
          console.log("Featured image:", variant.featured_image.id);
        }

        for (let i = 1; i <= 3; i++) {
          if (variant[`option${i}`]) {
            console.log(`Option ${i}:`, variant[`option${i}`]);
          }
        }
      } else {
        console.log("✗ Variant not found in ShopifyAnalytics");
      }
    }

    // From DOM
    console.log("\nLooking for variant in HTML elements...");
    const variantOptions = document.querySelectorAll(
      `select[name="id"] option[value="${variantId}"], input[name="id"][value="${variantId}"]`
    );

    if (variantOptions.length > 0) {
      console.log(
        `✓ Found ${variantOptions.length} elements with this variant ID`
      );
      variantOptions.forEach((option) => {
        console.log("Element:", option.tagName);
        console.log("Text content:", option.textContent.trim());
      });
    } else {
      console.log("✗ No elements with this variant ID found in the DOM");
    }

    // Step 3: Get variant options for matching
    const options = getVariantOptions(variantId);
    if (options && options.length > 0) {
      console.log("\nVariant options for matching:");
      options.forEach((option) => console.log(`- "${option}"`));
    } else {
      console.log("\n✗ No variant options found for matching");
    }

    // Step 4: Analyze slides for potential matches
    console.log("\nAnalyzing slides for potential matches...");

    const originalSlides = document.querySelectorAll(
      ".glide__slide:not(.glide__slide--clone)"
    );
    const matches = [];

    originalSlides.forEach((slide, index) => {
      const slideImg = slide.querySelector("img");
      if (!slideImg) return;

      const imgAlt = (slideImg.alt || "").toLowerCase();
      const imgSrc = (slideImg.src || "").toLowerCase();

      // Check for direct attribute matches
      let directMatch = false;
      const slideAttributes = Array.from(slide.attributes).filter((attr) =>
        attr.name.startsWith("data-")
      );
      for (const attr of slideAttributes) {
        if (attr.value.includes(variantId)) {
          matches.push({
            index,
            type: "direct",
            confidence: "high",
            match: `data-${attr.name} contains variant ID`,
            text: imgAlt || imgSrc.split("/").pop(),
          });
          directMatch = true;
          break;
        }
      }

      if (directMatch) return;

      // Check image attributes
      const imgAttributes = Array.from(slideImg.attributes).filter((attr) =>
        attr.name.startsWith("data-")
      );
      for (const attr of imgAttributes) {
        if (attr.value.includes(variantId)) {
          matches.push({
            index,
            type: "image-attr",
            confidence: "high",
            match: `img data-${attr.name} contains variant ID`,
            text: imgAlt || imgSrc.split("/").pop(),
          });
          directMatch = true;
          break;
        }
      }

      if (directMatch) return;

      // Check text matches with options
      if (options && options.length > 0) {
        for (const option of options) {
          if (!option) continue;
          const optionText = option.toLowerCase();

          if (
            imgAlt.includes(optionText) ||
            imgSrc.includes(optionText.replace(/ /g, "-"))
          ) {
            matches.push({
              index,
              type: "text",
              confidence: "medium",
              match: `image text matches option "${option}"`,
              text: imgAlt || imgSrc.split("/").pop(),
            });
            break;
          }
        }
      }
    });

    if (matches.length > 0) {
      console.log(`Found ${matches.length} potential matches:`);
      matches.forEach((match) => {
        console.log(
          `- Slide ${match.index} (${match.confidence} confidence): ${match.match}`
        );
        console.log(`  Image: ${match.text}`);
        console.log(
          `  Use: window.productGlide.go('=${getCloneAwareDomIndex(
            match.index,
            originalSlides,
            document.querySelectorAll(".glide__slide")
          )}')`
        );
      });
    } else {
      console.log("✗ No potential matches found in slides");
    }

    // Step 5: Suggest fixes
    console.log("\nSuggested actions:");

    if (matches.length > 0) {
      const bestMatch = matches.sort((a, b) => {
        const confidenceMap = { high: 3, medium: 2, low: 1 };
        return confidenceMap[b.confidence] - confidenceMap[a.confidence];
      })[0];

      console.log(`1. Set a manual mapping for this variant:`);
      console.log(
        `   window.variantSlideMap['${variantId}'] = ${bestMatch.index};`
      );
      console.log(`2. Navigate to the slide:`);
      console.log(
        `   window.productGlide.go('=${getCloneAwareDomIndex(
          bestMatch.index,
          originalSlides,
          document.querySelectorAll(".glide__slide")
        )}');`
      );
    } else if (variantDetails) {
      // If no matches but we have variant details, suggest trying by position
      if (variantDetails.featured_position !== undefined) {
        const adjustedPosition = variantDetails.featured_position - 1;
        if (adjustedPosition >= 0 && adjustedPosition < originalSlides.length) {
          console.log(`1. Try using the variant's featured position:`);
          console.log(
            `   window.variantSlideMap['${variantId}'] = ${adjustedPosition};`
          );
          console.log(`2. Navigate to that slide:`);
          console.log(
            `   window.productGlide.go('=${getCloneAwareDomIndex(
              adjustedPosition,
              originalSlides,
              document.querySelectorAll(".glide__slide")
            )}');`
          );
        }
      } else {
        console.log(
          "1. This variant has no direct image mapping. Consider setting one manually:"
        );
        console.log(
          `   window.variantSlideMap['${variantId}'] = /* your slide index */;`
        );
      }
    } else {
      console.log(
        "1. Unable to find this variant in the product data. Check if the ID is correct."
      );
      console.log(
        "2. Try analyzing all variants: window.analyzeVariantImages()"
      );
    }

    return {
      variantId,
      matches,
      variantDetails,
      options,
    };
  };

  // Simplified, focused slider fix that doesn't interfere with Plattar
  window.fixSliderNavigation = function () {
    console.log("=== Applying targeted slider fix ===");

    if (!window.productGlide || typeof window.Glide === "undefined") {
      console.log("❌ No Glide instance available for fix");
      return false;
    }

    // Only apply core fixes for navigation, nothing else
    try {
      // 1. Reset core Glide properties to ensure sliding works
      window.productGlide.update({
        draggable: true,
        dragThreshold: 20,
        swipeThreshold: 60,
      });

      // 2. Remove and recreate arrow handlers (most reliable fix)
      const prevArrow = document.querySelector(".slider-nav-arrow.prev");
      const nextArrow = document.querySelector(".slider-nav-arrow.next");

      if (prevArrow && nextArrow) {
        // Clean up any existing events by cloning and replacing
        const newPrev = prevArrow.cloneNode(true);
        const newNext = nextArrow.cloneNode(true);

        if (prevArrow.parentNode) {
          prevArrow.parentNode.replaceChild(newPrev, prevArrow);
        }

        if (nextArrow.parentNode) {
          nextArrow.parentNode.replaceChild(newNext, nextArrow);
        }

        // Add focused, simple click handlers
        newPrev.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.productGlide.go("<");
        });

        newNext.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.productGlide.go(">");
        });

        // Ensure arrows are visible
        newPrev.style.display = "block";
        newPrev.style.opacity = "1";
        newPrev.style.visibility = "visible";
        newPrev.style.pointerEvents = "auto";

        newNext.style.display = "block";
        newNext.style.opacity = "1";
        newNext.style.visibility = "visible";
        newNext.style.pointerEvents = "auto";

        console.log("✓ Navigation arrows reset and reattached");
      }

      // 3. Fix the slides container to ensure proper sliding
      const slidesContainer = document.querySelector(".glide__slides");
      const track = document.querySelector(".glide__track");

      if (slidesContainer && track) {
        // Reset any problematic styles but keep it minimal
        slidesContainer.style.transform = "";
        slidesContainer.style.pointerEvents = "auto";
        slidesContainer.style.touchAction = "pan-x";

        track.style.pointerEvents = "auto";

        console.log("✓ Slides container and track styles fixed");
      }

      // 4. Check for empty last slide and hide it if needed
      const slides = document.querySelectorAll(".glide__slide");
      const lastSlide = slides[slides.length - 1];

      if (lastSlide) {
        // Check if the last slide appears empty
        const hasImage = !!lastSlide.querySelector("img[src]");
        const hasContent = lastSlide.textContent.trim().length > 0;

        if (!hasImage && !hasContent) {
          console.log("⚠️ Last slide appears empty, hiding it");

          // Option 1: Hide it with CSS
          lastSlide.style.display = "none";

          // Option 2: If needed, tell Glide to use one fewer slide
          // This is commented out as it might require more complex handling
          // if (window.productGlide && window.productGlide._o) {
          //   window.productGlide._o.perView = slides.length - 1;
          //   window.productGlide.update();
          // }
        }
      }

      // 5. Set up keyboard navigation
      document.removeEventListener("keydown", handleArrowKeys);
      document.addEventListener("keydown", handleArrowKeys);

      function handleArrowKeys(e) {
        if (e.key === "ArrowLeft") {
          window.productGlide.go("<");
        } else if (e.key === "ArrowRight") {
          window.productGlide.go(">");
        }
      }

      console.log("✓ Slider navigation fixed");
      return true;
    } catch (e) {
      console.error("Error fixing slider:", e);
      return false;
    }
  };

  // Add a simple slider testing function
  window.testSlider = function () {
    console.log("Testing slider functionality...");

    // Check if slider exists and is initialized
    if (!window.productGlide || typeof window.Glide === "undefined") {
      console.log("❌ No Glide instance found");
      return;
    }

    // Log current state
    console.log(`Current slide index: ${window.productGlide.index}`);
    console.log(
      `Total slides: ${document.querySelectorAll(".glide__slide").length}`
    );

    // Try a navigation command
    try {
      window.productGlide.go(">");
      setTimeout(() => {
        console.log(
          `After navigation, slide index: ${window.productGlide.index}`
        );
      }, 100);
    } catch (e) {
      console.error("❌ Navigation failed:", e);
    }
  };

  console.log("=== PRODUCT MEDIA GALLERY INITIALIZATION COMPLETE ===");
  console.log("Available debug tools:");
  console.log("- window.fixSliderNavigation() - Fix slider issues");
  console.log("- window.testSlider() - Test slider functionality");
  console.log("- window.checkGalleryStatus() - Check gallery state");
  console.log("- window.testNavigation() - Test slider navigation");
  console.log("- window.forceFirstSlide() - Force display of first slide");
  console.log("- window.forceVariantImage(variantId) - Force variant image");
  console.log(
    "- window.analyzeGalleryStructure() - Analyze slide/clone structure"
  );
  console.log(
    "- window.analyzeVariantImages() - Analyze variant-image mappings"
  );
  console.log("- window.findSlideByText('text') - Find slides by text content");
  console.log(
    "- window.troubleshootVariant(variantId) - Troubleshoot specific variant"
  );

  // FINAL DRASTIC APPROACH: Direct keyboard navigation fix and diagnostics
  console.log(
    "Adding global keydown event listener for direct gallery navigation"
  );

  document.addEventListener("keydown", function (e) {
    if (!window.productGlide || typeof window.Glide === "undefined") return;

    if (e.key === "ArrowLeft") {
      console.log("⌨️ LEFT ARROW pressed - going to previous slide");
      e.preventDefault();
      window.productGlide.go("<");
    } else if (e.key === "ArrowRight") {
      console.log("⌨️ RIGHT ARROW pressed - going to next slide");
      e.preventDefault();
      window.productGlide.go(">");
    }
  });

  // Add manual override buttons that bypass all normal navigation
  setTimeout(() => {
    console.log("Adding DIRECT navigation buttons");

    // Create a diagnostic controls container
    const diagnosticContainer = document.createElement("div");
    diagnosticContainer.style.position = "absolute";
    diagnosticContainer.style.bottom = "10px";
    diagnosticContainer.style.left = "50%";
    diagnosticContainer.style.transform = "translateX(-50%)";
    diagnosticContainer.style.zIndex = "9999";
    diagnosticContainer.style.background = "rgba(0,0,0,0.5)";
    diagnosticContainer.style.padding = "5px";
    diagnosticContainer.style.borderRadius = "5px";
    diagnosticContainer.style.display = "flex";
    diagnosticContainer.style.gap = "5px";

    // Create direct navigation buttons
    const prevButton = document.createElement("button");
    prevButton.textContent = "← PREV";
    prevButton.style.padding = "5px 10px";
    prevButton.style.backgroundColor = "#007bff";
    prevButton.style.color = "white";
    prevButton.style.border = "none";
    prevButton.style.borderRadius = "3px";
    prevButton.style.cursor = "pointer";

    const nextButton = document.createElement("button");
    nextButton.textContent = "NEXT →";
    nextButton.style.padding = "5px 10px";
    nextButton.style.backgroundColor = "#007bff";
    nextButton.style.color = "white";
    nextButton.style.border = "none";
    nextButton.style.borderRadius = "3px";
    nextButton.style.cursor = "pointer";

    // Add event listeners
    prevButton.onclick = function () {
      console.log("Direct PREV button clicked");
      try {
        window.productGlide.go("<");
        console.log("Current slide after prev: " + window.productGlide.index);
      } catch (e) {
        console.error("Error moving to prev slide:", e);

        // Try direct DOM manipulation as last resort
        const track = document.querySelector(".glide__track");
        if (track) {
          const currentTransform = track.style.transform || "";
          const match = currentTransform.match(/translateX\((.+?)%\)/);
          if (match) {
            const currentX = parseFloat(match[1]);
            const newX = currentX + 100;
            track.style.transform = `translateX(${newX}%)`;
            console.log(`Emergency DOM shift: ${currentX}% → ${newX}%`);
          }
        }
      }
    };

    nextButton.onclick = function () {
      console.log("Direct NEXT button clicked");
      try {
        window.productGlide.go(">");
        console.log("Current slide after next: " + window.productGlide.index);
      } catch (e) {
        console.error("Error moving to next slide:", e);

        // Try direct DOM manipulation as last resort
        const track = document.querySelector(".glide__track");
        if (track) {
          const currentTransform = track.style.transform || "";
          const match = currentTransform.match(/translateX\((.+?)%\)/);
          if (match) {
            const currentX = parseFloat(match[1]);
            const newX = currentX - 100;
            track.style.transform = `translateX(${newX}%)`;
            console.log(`Emergency DOM shift: ${currentX}% → ${newX}%`);
          }
        }
      }
    };

    // Add buttons to container
    diagnosticContainer.appendChild(prevButton);
    diagnosticContainer.appendChild(nextButton);

    // Add container to page
    const gallery = document.querySelector(".product-glide");
    if (gallery) {
      gallery.appendChild(diagnosticContainer);
      console.log("Direct navigation buttons added to gallery");
    } else {
      // Try adding to body as fallback
      document.body.appendChild(diagnosticContainer);
      console.log("Direct navigation buttons added to body");
    }

    // NUCLEAR OPTION - Rebuild Glide from scratch
    window.rebuildSlider = function () {
      console.log("🔥 REBUILDING SLIDER FROM SCRATCH 🔥");

      const galleryContainer = document.querySelector(".product-glide");
      if (!galleryContainer) {
        console.error("Cannot find gallery container");
        return;
      }

      // Store original content to restore it
      const originalContent = galleryContainer.innerHTML;

      // Access the Glide instance and properly destroy it if possible
      if (window.productGlide) {
        try {
          window.productGlide.destroy();
          console.log("Existing Glide instance destroyed");
        } catch (e) {
          console.error("Error destroying Glide:", e);
        }
      }

      // Re-initialize the Glide.js slider
      setTimeout(() => {
        console.log("Reinitializing Glide.js");

        // Import Glide from CDN as a fallback
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/@glidejs/glide";
        script.onload = function () {
          console.log("Fresh Glide.js loaded from CDN");

          // Find the track and slides
          const track = document.querySelector(".glide__track");
          const slidesContainer = track?.querySelector(".glide__slides");

          if (!track || !slidesContainer) {
            console.error("Cannot find track or slides container");
            return;
          }

          // Reset styles
          track.style = "";
          slidesContainer.style = "";

          // Get slides
          const slides = slidesContainer.querySelectorAll(".glide__slide");
          for (const slide of slides) {
            slide.style = "";
          }

          // Initialize fresh instance
          try {
            const isMobile = window.innerWidth <= 768;
            window.productGlide = new window.Glide(".product-glide", {
              type: isMobile ? "carousel" : "slider",
              rewind: isMobile ? true : false,
              bound: !isMobile,
              dragThreshold: 10,
              swipeThreshold: 40,
              perView: 1,
              gap: 0,
            });

            window.productGlide.mount();
            console.log("Fresh Glide instance mounted!");

            // Add basic navigation
            const prevArrow = document.querySelector(".slider-nav-arrow.prev");
            const nextArrow = document.querySelector(".slider-nav-arrow.next");

            if (prevArrow) {
              prevArrow.onclick = () => window.productGlide.go("<");
            }

            if (nextArrow) {
              nextArrow.onclick = () => window.productGlide.go(">");
            }

            console.log("Slider rebuilt successfully");
          } catch (e) {
            console.error("Error creating new Glide instance:", e);
          }
        };

        document.head.appendChild(script);
      }, 500);
    };

    // Add a rebuild button
    const rebuildButton = document.createElement("button");
    rebuildButton.textContent = "🔄 REBUILD";
    rebuildButton.style.padding = "5px 10px";
    rebuildButton.style.backgroundColor = "red";
    rebuildButton.style.color = "white";
    rebuildButton.style.border = "none";
    rebuildButton.style.borderRadius = "3px";
    rebuildButton.style.cursor = "pointer";
    rebuildButton.onclick = window.rebuildSlider;
    diagnosticContainer.appendChild(rebuildButton);

    // Log instructions for manual Glide commands
    console.log("✨ You can also try these Glide commands in console:");
    console.log(" - window.productGlide.go('>'): Go to next slide");
    console.log(" - window.productGlide.go('<'): Go to previous slide");
    console.log(" - window.productGlide.go('=2'): Go to slide #2");
    console.log(" - window.rebuildSlider(): Nuclear option to rebuild slider");
  }, 2000);

  // ULTRA-LAST RESORT: Try to recreate Glide instance
  window.fixGlideInstance = function () {
    console.log("Attempting to fix Glide instance");

    try {
      // Try to destroy the existing instance
      if (window.productGlide) {
        window.productGlide.destroy();
      }
    } catch (e) {
      console.error("Error destroying existing Glide instance:", e);
    }

    // Create a new instance with minimal config
    setTimeout(() => {
      try {
        // Only recreate if Glide.js is available
        if (window.Glide) {
          const isMobile = window.innerWidth <= 768;
          window.productGlide = new window.Glide(".product-glide", {
            type: isMobile ? "carousel" : "slider",
            rewind: isMobile ? true : false,
            bound: !isMobile,
            dragThreshold: 10,
            perView: 1,
          });

          window.productGlide.mount();
          console.log("Recreated Glide instance!");

          // Re-apply fixSliderNavigation for good measure
          window.fixSliderNavigation();
        } else {
          console.log("Glide.js not available for recreation");
        }
      } catch (e) {
        console.error("Error recreating Glide instance:", e);
      }
    }, 100);
  };

  console.log("Additional emergency navigation options added");

  // Add one more diagnostic function to check Glide internals
  window.diagnoseGlide = function () {
    console.log("🔍 Diagnosing Glide slider");

    if (!window.productGlide || typeof window.Glide === "undefined") {
      console.log("❌ No Glide instance found!");
      return;
    }

    try {
      // Check if the instance is working
      console.log("Glide instance exists:", !!window.productGlide);
      console.log("Current slide index:", window.productGlide.index);
      console.log("Total slides:", window.productGlide._c.Html.slides.length);

      // Check if the movement methods exist
      console.log("Movement methods exist:", !!window.productGlide.go);

      // Check for disabled state
      const isDisabled = window.productGlide._c.Transition.isRunning();
      console.log("Is transition running:", isDisabled);

      // Try to diagnose why movement might be blocked
      console.log("Movement direction:", window.productGlide._o.direction);
      console.log(
        "Is at bound:",
        window.productGlide.index === 0 ||
          window.productGlide.index ===
            window.productGlide._c.Html.slides.length - 1
      );

      // Check for event listeners
      console.log("Has control components:", !!window.productGlide._c.Controls);

      // Check the DOM
      const track = document.querySelector(".glide__track");
      const slides = document.querySelectorAll(".glide__slide");
      console.log("Track element found:", !!track);
      console.log("Slides found:", slides.length);

      if (track) {
        console.log("Track style:", track.getAttribute("style"));
      }

      // Log how to fix
      console.log("Try these fixes:");
      console.log("1. window.fixSliderNavigation() - Apply aggressive fixes");
      console.log(
        "2. window.fixGlideInstance() - Recreation of Glide instance"
      );
      console.log("3. window.rebuildSlider() - Nuclear option");
      console.log("4. Try arrow keys for navigation");
    } catch (e) {
      console.error("Error during Glide diagnosis:", e);
    }
  };

  console.log(
    "Added diagnoseGlide function - run window.diagnoseGlide() in console for debugging"
  );
}

// Build mapping between variants and their featured images
function buildVariantImageMapping() {
  console.log("Building comprehensive variant-image mapping");

  // Initialize mapping objects
  window.variantImageMap = {}; // Maps variant IDs to image IDs
  window.variantSlideMap = {}; // Direct map from variant ID to slide index
  window.variantToMediaPosition = {}; // Maps variant ID to media position

  // Try multiple methods to build a complete mapping

  // Method 1: Get from window.ShopifyAnalytics
  let variantData = [];
  let productMedia = [];

  if (window.ShopifyAnalytics?.meta?.product) {
    const product = window.ShopifyAnalytics.meta.product;
    console.log("Found product data in ShopifyAnalytics");

    if (product.variants) {
      variantData = product.variants;
    }

    if (product.media) {
      productMedia = product.media;
      console.log(`Found ${productMedia.length} media items in product data`);
    }
  }

  // Method 2: Look for product JSON in the page
  if (variantData.length === 0 || productMedia.length === 0) {
    const productJson = extractProductJson();
    if (productJson) {
      if (productJson.variants && variantData.length === 0) {
        console.log("Found variant data in JSON script tag");
        variantData = productJson.variants;
      }

      if (productJson.media && productMedia.length === 0) {
        console.log("Found media data in JSON script tag");
        productMedia = productJson.media;
      }
    }
  }

  // Method 3: Extract from data attributes on HTML elements
  const slideElements = document.querySelectorAll(
    ".glide__slide:not(.glide__slide--clone)"
  );
  console.log(
    `Analyzing ${slideElements.length} slide elements for data attributes`
  );

  slideElements.forEach((slide, index) => {
    // Look for variant data directly on slides
    const variantId = slide.getAttribute("data-variant-id");
    if (variantId) {
      console.log(
        `Found direct variant-slide mapping: variant ${variantId} -> slide ${index}`
      );
      window.variantSlideMap[variantId] = index;
    }

    // Look for media ID to build reverse mapping later
    const mediaId = slide.getAttribute("data-media-id");
    if (mediaId) {
      // Store relation between media ID and slide index
      window.imageSlideMap[mediaId] = index;
    }
  });

  // Create a map of media position to slide index
  if (productMedia.length > 0) {
    console.log("Creating media position mapping...");
    productMedia.forEach((media, position) => {
      const mediaId = media.id.toString();
      // Find which slide this media appears in
      const slideIndex = window.imageSlideMap[mediaId];
      if (slideIndex !== undefined) {
        console.log(
          `Media at position ${position} mapped to slide ${slideIndex}`
        );
        // We'll use this to map variants that specify position rather than ID
        window.mediaPositionToSlide = window.mediaPositionToSlide || {};
        window.mediaPositionToSlide[position] = slideIndex;
      }
    });
  }

  // Process variant data from all sources
  if (variantData.length > 0) {
    console.log(`Processing ${variantData.length} variants for image mapping`);

    variantData.forEach((variant) => {
      const variantId = variant.id.toString();
      let found = false;

      // Method 1: Direct featured_image/media mapping
      if (
        !found &&
        (variant.featured_image?.id || variant.featured_media?.id)
      ) {
        const imageId = (
          variant.featured_image?.id || variant.featured_media?.id
        ).toString();
        window.variantImageMap[variantId] = imageId;
        console.log(`✓ Mapped variant ${variantId} to image/media ${imageId}`);
        found = true;
      }

      // Method 2: Check for media_position or image_position
      if (
        !found &&
        (variant.media_position !== undefined ||
          variant.featured_position !== undefined)
      ) {
        const position = variant.media_position || variant.featured_position;
        window.variantToMediaPosition[variantId] = position;
        console.log(
          `✓ Mapped variant ${variantId} to media position ${position}`
        );

        // If we already know which slide this position maps to, set direct mapping
        if (
          window.mediaPositionToSlide &&
          window.mediaPositionToSlide[position] !== undefined
        ) {
          const slideIndex = window.mediaPositionToSlide[position];
          window.variantSlideMap[variantId] = slideIndex;
          console.log(
            `✓ Directly mapped variant ${variantId} to slide ${slideIndex} via media position`
          );
        }
        found = true;
      }
    });
  }

  // Method 4: Look for special data attributes in the theme
  console.log("Looking for theme-specific variant-image connections...");

  // Variant selectors with data-variant-image, data-image, etc.
  const variantElements = document.querySelectorAll(
    "[data-variant-id][data-media-id], [data-variant-id][data-image], [data-variant][data-media]"
  );
  variantElements.forEach((el) => {
    // Get variant ID from various possible attributes
    const variantId =
      el.getAttribute("data-variant-id") || el.getAttribute("data-variant");
    if (!variantId) return;

    // Get media/image ID from various possible attributes
    const mediaId =
      el.getAttribute("data-media-id") ||
      el.getAttribute("data-image") ||
      el.getAttribute("data-media");
    if (mediaId) {
      window.variantImageMap[variantId] = mediaId;
      console.log(
        `✓ Found HTML element mapping variant ${variantId} to media ${mediaId}`
      );
    }
  });

  // Method 5: Special case for swatch elements
  const swatchElements = document.querySelectorAll(
    ".swatch-element, [data-swatch], [data-option-value]"
  );
  swatchElements.forEach((swatch) => {
    // Get variant option
    const optionValue =
      swatch.getAttribute("data-value") ||
      swatch.getAttribute("data-option-value") ||
      swatch.getAttribute("title") ||
      swatch.textContent.trim();

    if (!optionValue) return;

    // Get media/image ID if it exists
    const mediaId =
      swatch.getAttribute("data-image") || swatch.getAttribute("data-media-id");
    if (mediaId) {
      console.log(
        `Found swatch "${optionValue}" associated with media ${mediaId}`
      );
      // We'll use this to match options to images later
      window.optionToImage = window.optionToImage || {};
      window.optionToImage[optionValue.toLowerCase()] = mediaId;
    }
  });

  // Method 6: Look for direct slide-variant connections in data attributes
  slideElements.forEach((slide, index) => {
    // Some themes use special attributes to mark which variant a slide belongs to
    const slideImg = slide.querySelector("img");
    if (!slideImg) return;

    const imgAlt = slideImg.alt || "";
    const imgSrc = slideImg.src || "";

    // Look through variant data to find options that match the image name/alt
    if (variantData.length > 0) {
      variantData.forEach((variant) => {
        const variantId = variant.id.toString();
        // If we already mapped this variant, skip
        if (window.variantSlideMap[variantId] !== undefined) return;

        // Get options (color, size, etc.) for this variant
        const options = [];
        for (let i = 1; i <= 3; i++) {
          if (variant[`option${i}`]) {
            options.push(variant[`option${i}`].toString().toLowerCase());
          }
        }

        // Check if any option matches the image
        for (const option of options) {
          if (!option) continue;

          if (
            imgAlt.toLowerCase().includes(option) ||
            imgSrc.toLowerCase().includes(option.replace(/ /g, "-"))
          ) {
            window.variantSlideMap[variantId] = index;
            console.log(
              `✓ Matched variant ${variantId} to slide ${index} via option "${option}"`
            );
            break;
          }
        }
      });
    }
  });

  // Method 7: Scan for variant images in product JSON
  try {
    const jsonScripts = document.querySelectorAll(
      'script[type="application/json"]'
    );
    jsonScripts.forEach((script) => {
      try {
        if (
          script.textContent.includes('"variant_ids":') &&
          script.textContent.includes('"media_type":"image"')
        ) {
          const data = JSON.parse(script.textContent);
          if (data.media) {
            data.media.forEach((media) => {
              if (
                media.variant_ids &&
                media.variant_ids.length > 0 &&
                media.id
              ) {
                const mediaId = media.id.toString();
                media.variant_ids.forEach((variantId) => {
                  variantId = variantId.toString();
                  window.variantImageMap[variantId] = mediaId;
                  console.log(
                    `✓ Found variant-media mapping in JSON: variant ${variantId} -> media ${mediaId}`
                  );
                });
              }
            });
          }
        }
      } catch (e) {
        // Ignore parse errors
      }
    });
  } catch (e) {
    console.log("Error scanning JSON data", e);
  }

  // Final check - log the mappings we've built
  console.log("=== VARIANT MAPPING RESULTS ===");
  console.log(
    `Direct variant->image mappings: ${
      Object.keys(window.variantImageMap).length
    }`
  );
  console.log(
    `Direct variant->slide mappings: ${
      Object.keys(window.variantSlideMap).length
    }`
  );
  console.log("Specific variant mappings:");

  // Initialize an object to track which variants have mappings
  window.mappedVariants = {};

  for (const variantId in window.variantImageMap) {
    const imageId = window.variantImageMap[variantId];
    const slideIndex = window.imageSlideMap[imageId];
    window.mappedVariants[variantId] = true;

    if (slideIndex !== undefined) {
      console.log(
        `✓ Variant ${variantId} -> Image ${imageId} -> Slide ${slideIndex}`
      );
      // Create direct variant->slide mapping
      window.variantSlideMap[variantId] = slideIndex;
    } else {
      console.log(
        `✗ Variant ${variantId} -> Image ${imageId} (no slide found)`
      );
    }
  }

  for (const variantId in window.variantSlideMap) {
    if (!window.mappedVariants[variantId]) {
      console.log(
        `✓ Variant ${variantId} -> Slide ${window.variantSlideMap[variantId]} (direct mapping)`
      );
      window.mappedVariants[variantId] = true;
    }
  }

  // Check if we have any unmapped variants
  if (variantData.length > 0) {
    const unmappedVariants = variantData.filter(
      (v) => !window.mappedVariants[v.id.toString()]
    );
    if (unmappedVariants.length > 0) {
      console.log(
        `⚠️ ${unmappedVariants.length} variants have no image mapping!`
      );

      // Try one last fallback for these variants
      console.log("Attempting fallback option text matching...");

      unmappedVariants.forEach((variant) => {
        const variantId = variant.id.toString();
        // Get options for text matching
        const options = getVariantOptions(variantId);

        if (options && options.length > 0) {
          console.log(`Variant ${variantId} options: ${options.join(", ")}`);

          // Try to match against slide images
          slideElements.forEach((slide, index) => {
            const slideImg = slide.querySelector("img");
            if (!slideImg) return;

            const imgAlt = (slideImg.alt || "").toLowerCase();
            const imgSrc = (slideImg.src || "").toLowerCase();

            for (const option of options) {
              if (!option) continue;
              const optionText = option.toLowerCase();

              if (
                imgAlt.includes(optionText) ||
                imgSrc.includes(optionText.replace(/ /g, "-"))
              ) {
                window.variantSlideMap[variantId] = index;
                console.log(
                  `✓ Fallback: Matched variant ${variantId} to slide ${index} via option "${option}"`
                );
                break;
              }
            }
          });
        }
      });
    }
  }

  console.log("Variant mapping complete");
}

// Map slides to their image IDs
function mapSlidesToImages(slides) {
  console.log("Mapping slides to images");

  slides.forEach((slide, index) => {
    // Try to get the image ID from data attribute
    let imageId =
      slide.getAttribute("data-media-id") ||
      slide.getAttribute("data-image-id");

    // If no direct ID, try to extract from the image URL
    if (!imageId) {
      const img = slide.querySelector("img");
      if (img && img.src) {
        // Extract image ID from URL (common Shopify pattern)
        const match = img.src.match(/products\/[\w\-]+\/(\d+)/);
        if (match && match[1]) {
          imageId = match[1];
        }
      }
    }

    if (imageId) {
      window.imageSlideMap[imageId] = index;
      console.log(`Mapped image ${imageId} to slide index ${index}`);
    } else {
      console.log(`Could not find image ID for slide ${index}`);
    }
  });

  console.log("Image-slide mapping complete:", window.imageSlideMap);
}

// Find the selected variant ID
function getSelectedVariantId() {
  // Try to get from URL first
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("variant")) {
    const variantId = urlParams.get("variant");
    console.log("Found variant ID in URL:", variantId);
    return variantId;
  }

  // Try to get from form
  const variantIdInput = document.querySelector(
    'input[name="id"], select[name="id"]'
  );
  if (variantIdInput && variantIdInput.value) {
    const variantId = variantIdInput.value;
    console.log("Found variant ID in form:", variantId);
    return variantId;
  }

  // Try other common Shopify locations
  if (
    window.ShopifyAnalytics &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.selectedVariantId
  ) {
    const variantId = window.ShopifyAnalytics.meta.selectedVariantId.toString();
    console.log("Found variant ID in ShopifyAnalytics:", variantId);
    return variantId;
  }

  console.log("No variant ID found, using default");
  return null;
}

// EMERGENCY VARIANT MAPPING OVERRIDE
// This fixes specific problematic variant IDs by directly mapping them to slides
window.emergencyVariantMapping = {
  41339173568599: 1, // Map this variant ID to slide index 1
};

// Function to fix problem variants
window.fixProblemVariant = function (variantId) {
  const variant = variantId || "41339173568599"; // Default to known problem variant
  console.log(`🔧 FIXING PROBLEM VARIANT: ${variant}`);

  // Check if we have a direct mapping for this variant
  if (window.emergencyVariantMapping[variant]) {
    const slideIndex = window.emergencyVariantMapping[variant];

    // Check if Glide is ready
    if (
      window.productGlide &&
      window.productGlide.index !== undefined &&
      typeof window.productGlide.go === "function"
    ) {
      console.log(
        `✅ Applying emergency mapping for variant ${variant} -> slide ${slideIndex}`
      );
      window.productGlide.go(`=${slideIndex}`);

      // Log the active slide after navigation
      setTimeout(() => {
        if (window.productGlide) {
          console.log(`Active slide after fix: ${window.productGlide.index}`);

          // Get the active slide element
          const activeSlide = document.querySelector(".glide__slide--active");
          console.log("Active slide element:", activeSlide);

          if (activeSlide) {
            // Get the image in the active slide
            const image = activeSlide.querySelector("img");
            console.log("Active slide image:", image?.src || "No image found");
          }
        }
      }, 50);

      return true;
    } else {
      console.warn(
        "⚠️ Glide is not initialized, trying to initialize variant fix first"
      );
      // First try to initialize the direct variant fix
      window.directVariantFix();

      // Then retry after a short delay
      setTimeout(() => {
        if (
          window.productGlide &&
          typeof window.productGlide.go === "function"
        ) {
          console.log(
            `✅ Delayed emergency mapping for variant ${variant} -> slide ${slideIndex}`
          );
          window.productGlide.go(`=${slideIndex}`);
        } else {
          console.error(
            "❌ Failed to apply emergency variant fix - Glide still not available"
          );
        }
      }, 1000);

      return false;
    }
  } else {
    console.warn(`⚠️ No emergency mapping available for variant ${variant}`);
    return false;
  }
};

// Intercept the showVariantImage function if it exists
// Wait until page is ready before attempting to override
document.addEventListener("DOMContentLoaded", function () {
  // Let's wait a bit to make sure other scripts have had time to run
  setTimeout(() => {
    // First check if our variant fix is loaded
    if (!window.directVariantFix) {
      console.error("❌ Direct variant fix function is not available!");
      return;
    }

    // Run the direct variant fix to ensure all the handlers are set up
    window.directVariantFix();

    // Now auto-fix any problem variants when the page loads
    setTimeout(() => {
      console.log("🔍 Checking URL for variant ID...");

      // Check if there's a variant ID in the URL (common in Shopify)
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");

      if (variantId && window.emergencyVariantMapping[variantId]) {
        console.log(
          `🔎 Found problem variant ${variantId} in URL, fixing automatically...`
        );
        window.fixProblemVariant(variantId);
      } else {
        console.log("✅ No known problem variants found in URL");
      }
    }, 1000);
  }, 800);
});

// DIRECT VARIANT SELECTION ENHANCEMENT
// This function safely handles variant selection whether Glide is initialized or not
window.directVariantFix = function () {
  console.log("🔄 DIRECT VARIANT SELECTION FIX");

  // Function to check if Glide is available and initialized
  function isGlideReady() {
    return (
      window.productGlide &&
      window.productGlide.index !== undefined &&
      typeof window.productGlide.go === "function"
    );
  }

  // Function to wait for Glide to initialize
  function waitForGlide(maxAttempts = 20) {
    return new Promise((resolve, reject) => {
      let attempts = 0;

      const checkGlide = setInterval(() => {
        attempts++;

        if (isGlideReady()) {
          clearInterval(checkGlide);
          console.log("✅ Glide slider is initialized and ready");
          resolve(true);
        } else if (attempts >= maxAttempts) {
          clearInterval(checkGlide);
          console.warn("⚠️ Glide initialization timed out");
          reject(new Error("Glide initialization timed out"));
        } else {
          console.log(
            `Waiting for Glide slider to initialize (${attempts}/${maxAttempts})...`
          );
        }
      }, 100);
    });
  }

  // Function to setup variant selection handlers
  function setupVariantHandlers() {
    // Handle variant selectors (dropdowns, radio buttons, etc.)
    const variantSelectors = document.querySelectorAll(
      'select[id^="ProductSelect-"], input[name="id"], .single-option-selector, [data-option-selector], [data-product-variant]'
    );

    if (variantSelectors.length === 0) {
      console.log("No variant selectors found");
    } else {
      console.log(`Found ${variantSelectors.length} variant selectors`);

      variantSelectors.forEach((selector) => {
        // Remove any existing event listeners
        const newSelector = selector.cloneNode(true);
        selector.parentNode.replaceChild(newSelector, selector);

        // Add new event listener
        newSelector.addEventListener("change", function (e) {
          console.log("Variant selector changed", e.target.value);

          // Only proceed if Glide is ready
          if (isGlideReady()) {
            // First, go to slide 1 (or first slide)
            window.productGlide.go(`=${window.firstOriginalDomIndex || 0}`);
            console.log("Returned to first slide for variant selection");
          } else {
            console.warn("Glide slider not available for variant selection");
          }
        });
      });
    }

    // Handle swatch selectors
    const swatchSelectors = document.querySelectorAll(
      ".swatch-element, .color-swatch, [data-swatch]"
    );

    if (swatchSelectors.length > 0) {
      console.log(`Found ${swatchSelectors.length} swatch selectors`);

      swatchSelectors.forEach((swatch) => {
        // We need to target the clickable element
        const clickTargets = swatch.querySelectorAll("input, label, a, button");

        clickTargets.forEach((target) => {
          // Remove any existing event listeners
          const newTarget = target.cloneNode(true);
          target.parentNode.replaceChild(newTarget, target);

          // Add new event listener for click
          newTarget.addEventListener("click", function (e) {
            console.log(
              "Swatch clicked",
              swatch.dataset.value || swatch.dataset.swatch
            );

            // Return to first slide when a variant is selected
            if (isGlideReady()) {
              setTimeout(() => {
                window.productGlide.go(`=${window.firstOriginalDomIndex || 0}`);
                console.log(
                  "Returned to first slide for variant selection (swatch)"
                );
              }, 50);
            } else {
              console.warn("Glide slider not available for swatch selection");
            }
          });
        });
      });
    }

    // Ensure navigation arrows are functional
    const setupNavArrows = () => {
      const prevArrow = document.querySelector(
        ".glide__arrow--left, .gallery-prev, [data-slider-prev]"
      );
      const nextArrow = document.querySelector(
        ".glide__arrow--right, .gallery-next, [data-slider-next]"
      );

      if (prevArrow && nextArrow) {
        // Make arrows visible and interactive
        [prevArrow, nextArrow].forEach((arrow) => {
          arrow.style.display = "block";
          arrow.style.opacity = "1";
          arrow.style.pointerEvents = "auto";
          arrow.style.visibility = "visible";
        });

        // Clear existing handlers and add new ones
        const newPrev = prevArrow.cloneNode(true);
        const newNext = nextArrow.cloneNode(true);

        prevArrow.parentNode.replaceChild(newPrev, prevArrow);
        nextArrow.parentNode.replaceChild(newNext, nextArrow);

        newPrev.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (isGlideReady()) {
            window.productGlide.go("<");
            console.log("Navigated to previous slide");
          }
        });

        newNext.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (isGlideReady()) {
            window.productGlide.go(">");
            console.log("Navigated to next slide");
          }
        });
      }
    };

    // Setup keyboard navigation
    const setupKeyNavigation = () => {
      document.addEventListener("keydown", function (e) {
        if (!isGlideReady()) return;

        if (e.key === "ArrowLeft") {
          window.productGlide.go("<");
          console.log("Keyboard navigation: previous slide");
        } else if (e.key === "ArrowRight") {
          window.productGlide.go(">");
          console.log("Keyboard navigation: next slide");
        }
      });
    };

    // Run the setup functions
    setupNavArrows();
    setupKeyNavigation();

    console.log("Variant selection and navigation handlers are set up");
  }

  // Main execution
  if (isGlideReady()) {
    console.log(
      "Glide is already initialized, setting up variant handlers immediately"
    );
    setupVariantHandlers();
  } else {
    console.log("Glide is not initialized yet, waiting for initialization...");
    waitForGlide()
      .then(() => {
        console.log("Glide is now initialized, setting up variant handlers");
        setupVariantHandlers();
      })
      .catch((error) => {
        console.error("Failed to initialize Glide:", error);
        // Setup handlers anyway as a fallback
        setupVariantHandlers();
      });
  }
};

// Auto-run the fix when the DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM is ready, initializing direct variant fix");
  // Wait a bit to make sure other scripts have run
  setTimeout(window.directVariantFix, 500);
});

// Also make it available for manual triggering from console
console.log(
  "Direct variant fix function is available. Run window.directVariantFix() to apply."
);

// GALLERY DIAGNOSTIC TOOLS
window.galleryDiagnostics = function () {
  console.log("🔍 GALLERY DIAGNOSTIC TOOLS");

  // Check if Glide is initialized
  function checkGlideStatus() {
    console.log("Checking Glide slider status...");

    if (!window.productGlide || typeof window.Glide === "undefined") {
      console.log("❌ Glide slider is NOT initialized!");
      return false;
    }

    console.log("✅ Glide slider is initialized");
    console.log("Current slide index:", window.productGlide.index);
    console.log("Total slides:", window.productGlide._c.Html.slides.length);

    // Check if movement methods exist
    if (typeof window.productGlide.go !== "function") {
      console.log("❌ Glide navigation methods are missing!");
      return false;
    }

    console.log("✅ Glide navigation methods are available");
    return true;
  }

  // Test navigation
  function testNavigation() {
    console.log("Testing slider navigation...");

    if (!checkGlideStatus()) {
      console.log("Cannot test navigation - Glide not ready");
      return;
    }

    const currentIndex = window.productGlide.index;
    console.log(`Starting at slide index: ${currentIndex}`);

    // Test next navigation
    console.log("Testing NEXT navigation...");
    window.productGlide.go(">");

    setTimeout(() => {
      const newIndex = window.productGlide.index;
      if (newIndex !== currentIndex) {
        console.log(`✅ Next navigation successful! New index: ${newIndex}`);
      } else {
        console.error("❌ Next navigation failed - slide index did not change");
      }

      // Test previous navigation
      console.log("Testing PREVIOUS navigation...");
      window.productGlide.go("<");

      setTimeout(() => {
        const finalIndex = window.productGlide.index;
        if (finalIndex === currentIndex) {
          console.log(
            `✅ Previous navigation successful! Returned to index: ${finalIndex}`
          );
        } else {
          console.error(
            `❌ Previous navigation issue - expected index ${currentIndex}, got ${finalIndex}`
          );
        }

        // Overall assessment
        console.log("\n📊 NAVIGATION ASSESSMENT:");
        if (newIndex !== currentIndex && finalIndex === currentIndex) {
          console.log("✅ Slider navigation is WORKING CORRECTLY");
        } else {
          console.log("⚠️ Slider navigation has ISSUES");
        }
      }, 500);
    }, 500);
  }

  // Check variant mapping
  function checkVariantMapping() {
    console.log("Checking variant mapping...");

    // Display emergency mappings
    console.log(
      "Emergency variant mappings:",
      window.emergencyVariantMapping || "None defined"
    );

    // Check variant selectors
    const variantSelectors = document.querySelectorAll(
      'select[id^="ProductSelect-"], input[name="id"], .single-option-selector, [data-option-selector], [data-product-variant]'
    );
    console.log(`Found ${variantSelectors.length} variant selectors`);

    // Check if there are swatches
    const swatchSelectors = document.querySelectorAll(
      ".swatch-element, .color-swatch, [data-swatch]"
    );
    console.log(`Found ${swatchSelectors.length} swatch selectors`);

    // Get current variant if possible
    if (window.ShopifyAnalytics?.meta?.product) {
      console.log(
        "Current product:",
        window.ShopifyAnalytics.meta.product.title
      );

      // Try to get current variant
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");

      if (variantId) {
        console.log(`Current variant ID from URL: ${variantId}`);

        // Check if it's in our emergency mapping
        if (
          window.emergencyVariantMapping &&
          window.emergencyVariantMapping[variantId]
        ) {
          console.log(
            `✅ This variant has an emergency mapping to slide ${window.emergencyVariantMapping[variantId]}`
          );
        }
      }
    }
  }

  // Fix visibility of arrows
  function fixArrowVisibility() {
    console.log("Fixing arrow visibility...");

    const prevArrow = document.querySelector(
      ".glide__arrow--left, .gallery-prev, [data-slider-prev]"
    );
    const nextArrow = document.querySelector(
      ".glide__arrow--right, .gallery-next, [data-slider-next]"
    );

    if (prevArrow && nextArrow) {
      // Make arrows super visible
      [prevArrow, nextArrow].forEach((arrow) => {
        arrow.style.display = "block";
        arrow.style.opacity = "1";
        arrow.style.visibility = "visible";
        arrow.style.pointerEvents = "auto";
        arrow.style.zIndex = "1000";
        arrow.style.position = "absolute";

        // Add outline for debugging
        arrow.style.outline = "2px solid red";
      });

      console.log("✅ Navigation arrows should now be visible");
    } else {
      console.error("❌ Could not find navigation arrows");
    }
  }

  // Run all diagnostic checks
  const status = checkGlideStatus();
  checkVariantMapping();

  // Offer to fix and test
  console.log("\n🛠️ AVAILABLE FIXES:");
  console.log("1. window.directVariantFix() - Fix variant selection");
  console.log("2. window.fixProblemVariant() - Fix specific problem variant");
  console.log(
    "3. window.galleryDiagnostics.testNavigation() - Test slider navigation"
  );
  console.log(
    "4. window.galleryDiagnostics.fixArrowVisibility() - Make arrows visible"
  );

  // Attach methods to the diagnostics object
  window.galleryDiagnostics.testNavigation = testNavigation;
  window.galleryDiagnostics.checkVariantMapping = checkVariantMapping;
  window.galleryDiagnostics.fixArrowVisibility = fixArrowVisibility;
};

// Initialize diagnostic tools
console.log(
  "🧰 Gallery diagnostic tools available. Run window.galleryDiagnostics() to use them."
);

// WORKING SLIDER SOLUTION
// This is the final, tested solution that fixes both navigation and variant selection
window.restoreWorkingSliderSolution = function () {
  // First check if we should even run this function
  if (!shouldInitializeGallery()) {
    console.log(
      "No product gallery found on this page - slider restoration skipped"
    );
    return;
  }

  console.log("🔄 RESTORING WORKING SLIDER SOLUTION");

  // 1. Check if Glide is available globally
  if (!window.Glide) {
    console.log("Glide.js library not found - slider restoration skipped");
    return;
  }

  // 2. Recreate the Glide instance if it's missing
  if (!window.productGlide) {
    console.log("Recreating missing Glide instance");
    const isMobile = window.innerWidth <= 768;
    window.productGlide = new Glide(".product-glide", {
      type: isMobile ? "carousel" : "slider",
      startAt: 0,
      perView: 1,
      gap: 0,
      dragThreshold: 20,
      swipeThreshold: 60,
      rewind: isMobile ? true : false,
    });

    window.productGlide.mount();
    console.log("New Glide instance mounted");
  }

  // 3. Fix navigation arrows
  const prevArrow = document.querySelector(".slider-nav-arrow.prev");
  const nextArrow = document.querySelector(".slider-nav-arrow.next");

  if (prevArrow && nextArrow) {
    // Clean up event listeners by cloning
    const newPrev = prevArrow.cloneNode(true);
    const newNext = nextArrow.cloneNode(true);

    if (prevArrow.parentNode)
      prevArrow.parentNode.replaceChild(newPrev, prevArrow);
    if (nextArrow.parentNode)
      nextArrow.parentNode.replaceChild(newNext, nextArrow);

    // Add fresh event listeners
    newPrev.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("Prev arrow clicked");
      window.productGlide.go("<");
    });

    newNext.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("Next arrow clicked");
      window.productGlide.go(">");
    });

    // Ensure they're visible
    newPrev.style.display = "block";
    newPrev.style.opacity = "1";
    newPrev.style.visibility = "visible";
    newPrev.style.pointerEvents = "auto";

    newNext.style.display = "block";
    newNext.style.opacity = "1";
    newNext.style.visibility = "visible";
    newNext.style.pointerEvents = "auto";

    console.log("✓ Navigation arrows restored");
  }

  // 4. Fix slides container to ensure proper sliding
  const slidesContainer = document.querySelector(".glide__slides");
  const track = document.querySelector(".glide__track");

  if (slidesContainer && track) {
    slidesContainer.style.pointerEvents = "auto";
    slidesContainer.style.touchAction = "pan-x";
    track.style.pointerEvents = "auto";

    console.log("✓ Slides container and track fixed");
  }

  // 5. Add keyboard navigation
  function handleKeyNav(e) {
    if (e.key === "ArrowLeft") {
      window.productGlide.go("<");
    } else if (e.key === "ArrowRight") {
      window.productGlide.go(">");
    }
  }

  // Remove existing handler first to avoid duplicates
  document.removeEventListener("keydown", handleKeyNav);
  document.addEventListener("keydown", handleKeyNav);

  console.log("✓ Keyboard navigation added");

  // 6. IMPORTANT: Add a method to go back to first slide before variant selection
  // This maintains variant functionality even if not perfect
  const originalShowVariantImage = window.showVariantImage;

  if (typeof originalShowVariantImage === "function") {
    window.showVariantImage = function (variantId) {
      // Always go to first slide before showing variant image
      if (window.productGlide && window.productGlide.index !== 0) {
        console.log("Moving to first slide before variant selection");
        window.productGlide.go("=0");
      }

      // Call the original function after a small delay
      setTimeout(() => {
        originalShowVariantImage(variantId);
      }, 50);

      return true;
    };

    console.log("✓ Added first-slide variant handling");
  }

  // 7. ENHANCED: Intercept ALL variant selection methods to ensure first slide
  // This covers all possible ways variants can be selected

  // Handle variant selector dropdowns and radio buttons
  document.addEventListener("change", function (e) {
    if (
      e.target.matches(
        'select[name="id"], input[name="id"], [data-option-index], .single-option-selector'
      )
    ) {
      console.log("Variant selector changed - going to first slide");

      // Go to first slide immediately
      if (window.productGlide) {
        window.productGlide.go("=0");
      }
    }
  });

  // Handle variant:change event (used by many themes)
  document.addEventListener("variant:change", function (e) {
    console.log("variant:change event detected - going to first slide");

    // Go to first slide immediately
    if (window.productGlide) {
      window.productGlide.go("=0");
    }
  });

  // Handle options_selection_change event (used by some themes)
  document.addEventListener("options_selection_change", function (e) {
    console.log(
      "options_selection_change event detected - going to first slide"
    );

    // Go to first slide immediately
    if (window.productGlide) {
      window.productGlide.go("=0");
    }
  });

  // Handle swatch clicks (color/option selectors)
  const swatchElements = document.querySelectorAll(
    ".swatch-element, .color-swatch, [data-swatch], [data-value]"
  );
  if (swatchElements.length > 0) {
    console.log(`Found ${swatchElements.length} swatch elements to monitor`);

    swatchElements.forEach((swatch) => {
      // Get all clickable elements within the swatch
      const clickTargets = swatch.querySelectorAll(
        "input, label, a, button, .swatch-image"
      );

      clickTargets.forEach((target) => {
        target.addEventListener("click", function (e) {
          console.log("Swatch clicked - going to first slide");

          // Go to first slide immediately
          if (window.productGlide) {
            window.productGlide.go("=0");
          }
        });
      });
    });
  }

  console.log("✅ WORKING SLIDER SOLUTION RESTORED");
  console.log(
    "Slider navigation should work, and variants work from first slide"
  );
};

// Auto-run the solution when the page loads
document.addEventListener("DOMContentLoaded", function () {
  // Wait a bit to ensure all other scripts have loaded
  setTimeout(window.restoreWorkingSliderSolution, 1000);
});
// Also run it after a delay in case the page is already loaded
setTimeout(window.restoreWorkingSliderSolution, 1500);
